// js
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Error, LoadingScreen } from '@its-svp/svp-common-ui';

// css
import '../styles/components/RouteUser.scss';

const RouteUser = (props) => {
  // A user should be able to reach any page in our app without issues caused by case sensitivity in the pathname
  // Routes user to the appropriate service without case-sensitivity (ex: /Welcome -> /welcome)
  let segments = window.location.pathname.split('/');
  if (segments[1] !== segments[1].toLowerCase()) {
    segments[1] = segments[1].toLowerCase();
    const caseInsensitivePath = segments.join('/');
    window.location.assign(caseInsensitivePath);
    return <LoadingScreen />;
  }

  return (
    <div className='svp-common-ui route-user'>
      <Error user={props.currentUser} status={props.status} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.user
  };
};

RouteUser.defaultProps = {
  status: 404
};

RouteUser.propTypes = {
  currentUser: PropTypes.object,
  status: PropTypes.number
};

export default connect(mapStateToProps)(RouteUser);



// WEBPACK FOOTER //
// ./src/components/RouteUser.js